import React from 'react'
import { Card, Separator, Bleed, colors, useTheme } from '@fs/zion-ui'
import { css } from '@emotion/core'
import RainbowDivider from '../RainbowDivider'
import {
  appleWavesJpg,
  blackWavesJpg,
  blueberryWavesJpg,
  duskWavesJpg,
  fireWavesJpg,
  mangoWavesJpg,
  seafoamWavesJpg,
  whiteWavesJpg,
} from '../../images'
import BlackText from '../BlackText'
import cardHeadingMap from './cardHeadingMap'
import zionHeadingMap from './zionHeadingMap'

const innerCardCss = css`
  padding: 4px;
  flex-grow: 1;
`
const imageFlavorMap = {
  apple: appleWavesJpg,
  blueberry: blueberryWavesJpg,
  mango: mangoWavesJpg,
  dusk: duskWavesJpg,
  fire: fireWavesJpg,
  seafoam: seafoamWavesJpg,
}

export default function BorderCard({
  heading,
  topHeading,
  topSeparator = false,
  hideDivider = false,
  flavor,
  children,
  margins = 'regular',
  as = 'h4',
}) {
  const TopHeading = topHeading ? zionHeadingMap[as] : null
  const Heading = !topHeading ? zionHeadingMap[as] : zionHeadingMap[cardHeadingMap[as]]
  const theme = useTheme()

  return (
    <Card backgroundImage={imageFlavorMap[flavor]} backgroundColor={colors.gray100}>
      {topSeparator && !topHeading && <Separator size="md" />}
      {topHeading && (
        <BlackText>
          <TopHeading size="H5" centered>
            {topHeading}
          </TopHeading>
          <Separator size="xxs" />
        </BlackText>
      )}
      <Bleed all css={innerCardCss}>
        <Card backgroundImage={theme === 'night' ? blackWavesJpg : whiteWavesJpg} margins={margins}>
          {heading && (
            <>
              <Separator size="nano" />
              <Heading size="H4">{heading}</Heading>
              <Separator size="xxs" />
            </>
          )}
          {!hideDivider && (
            <>
              <RainbowDivider thick and full of flavor="charcoal" />
              <Separator size="xxs" />
            </>
          )}
          {children}
        </Card>
      </Bleed>
    </Card>
  )
}
